function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#29B36A",
  d: "M30.77.538C21.87 3.11 14.9 11.63 10.113 19.704l-5.327-7.207c-1.888-2.554-6.22-.068-4.308 2.518L8.25 25.53c1.044 1.412 3.346 1.802 4.308 0 1.651-3.092 3.63-6.06 5.751-8.845 3.522-4.628 8.02-9.67 13.788-11.336 3.079-.89 1.77-5.705-1.326-4.811z"
});
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 27,
    fill: "none",
    viewBox: "0 0 34 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.395dab6fda98a4471928059034eae0a2.svg";
export { ForwardRef as ReactComponent };